import React from 'react';
import { Price, SearchKey } from '../adType';

function getPriceTagLabel(price: Price, searchKey: string, tradeType: string) {
    const currencyCode = price.currency_code !== 'NOK' ? price.currency_code : 'kr';
    const priceOrTradeType =
        price.amount > 0 && searchKey !== 'SEARCH_ID_BAP_WANTED'
            ? `${formatNumber(price.amount)} ${currencyCode}`
            : tradeType;
    return priceOrTradeType;
}

type PriceTagProps = {
    price: Price;
    searchKey: SearchKey;
    tradeType: string;
};

function PriceTag(props: PriceTagProps) {
    const { price, searchKey, tradeType } = props;

    const label = getPriceTagLabel(price, searchKey, tradeType);

    return (
        <span className="sf-ad-pricetag inline-block px-8 py-4 rounded-16 text-14 text-white">
            {label}
        </span>
    );
}

// http://stackoverflow.com/a/290129
export function formatNumber(number: number | string): string {
    if (typeof number === 'number') {
        number = String(number);
    }
    return number.replace(/\B(?=(\d{3})+(?!\d))/g, '$&\u00A0');
}

export default PriceTag;
